import React from 'react';
import { Row, Column, Label } from '../../../styles/WidgetCustomizer.styles';
import ColorPicker from '../../ColorPicker/ColorPicker';
import UnitInput from '../../UnitInput/UnitInput';
import { SettingsGroup } from '../../../styles/WidgetCustomizer.styles';

const ColorsTab = ({ colors, setColors }) => {
    return (
        <>
            <Row>
                <ColorPicker
                    label="Accent"
                    color={colors.accent}
                    onChange={(color) => setColors(prev => ({ ...prev, accent: color }))}
                />
            </Row>

            <Row>
                <ColorPicker
                    label="Background"
                    color={colors.background}
                    onChange={(color) => setColors(prev => ({ ...prev, background: color }))}
                />
                <ColorPicker
                    label="Border"
                    color={colors.borderColor}
                    onChange={(color) => setColors(prev => ({ ...prev, borderColor: color }))}
                />
            </Row>

            <Row>
                <ColorPicker
                    label="Time bar"
                    color={colors.timeBar}
                    onChange={(color) => setColors(prev => ({ ...prev, timeBar: color }))}
                />
            </Row>

            <Row>
                <ColorPicker
                    label="Button background"
                    color={colors.buttonBackground}
                    onChange={(color) => setColors(prev => ({ ...prev, buttonBackground: color }))}
                />
                <ColorPicker
                    label="History modal background"
                    color={colors.historyModalBg}
                    onChange={(color) => setColors(prev => ({ ...prev, historyModalBg: color }))}
                />
            </Row>
            <SettingsGroup>
                <Row>
                    <ColorPicker
                        label="Live indicator"
                        color={colors.liveIndicator}
                        onChange={(color) => setColors(prev => ({ ...prev, liveIndicator: color }))}
                    />
                    <ColorPicker
                        label="Text"
                        color={colors.text}
                        onChange={(color) => setColors(prev => ({ ...prev, text: color }))}
                    />
                </Row>
                <Row>
                    <ColorPicker
                        label="Icon"
                        color={colors.icon}
                        onChange={(color) => setColors(prev => ({ ...prev, icon: color }))}
                    />
                    <ColorPicker
                        label="History modal texts"
                        color={colors.historyModalTexts}
                        onChange={(color) => setColors(prev => ({ ...prev, historyModalTexts: color }))}
                    />
                </Row>
            </SettingsGroup>
            <Row>
                <Column>
                    <ColorPicker
                        label="Background shadow"
                        color={colors.backgroundShadow}
                        onChange={(color) => setColors(prev => ({ ...prev, backgroundShadow: color }))}
                    />
                </Column>
                <Column>
                    <Label>Background shadow angle</Label>
                    <UnitInput
                        value={colors.backgroundShadowAngle || "135"}
                        units={['deg']}
                        defaultUnit="deg"
                        onChange={({ value }) => {
                            setColors(prev => ({ ...prev, backgroundShadowAngle: value }))
                        }}
                    />
                </Column>
            </Row>
            <Row>
                <Column>
                    <Label>Background shadow blur</Label>
                    <UnitInput
                        value={colors.backgroundShadowBlur || "15"}
                        units={['px']}
                        defaultUnit="px"
                        onChange={({ value }) => {
                            setColors(prev => ({ ...prev, backgroundShadowBlur: value }))
                        }}
                    />
                </Column>
                <Column>
                    <Label>Background shadow offset</Label>
                    <UnitInput
                        value={colors.backgroundShadowOffset || "4"}
                        units={['px']}
                        defaultUnit="px"
                        onChange={({ value }) => {
                            setColors(prev => ({ ...prev, backgroundShadowOffset: value }))
                        }}
                    />
                </Column>
            </Row>
            <Row>
                <Column>
                    <ColorPicker
                        label="Button shadow"
                        color={colors.buttonShadow}
                        onChange={(color) => setColors(prev => ({ ...prev, buttonShadow: color }))}
                    />
                </Column>
                <Column>
                    <Label>Button shadow angle</Label>
                    <UnitInput
                        value={colors.buttonShadowAngle || "135"}
                        units={['deg']}
                        defaultUnit="deg"
                        onChange={({ value }) => {
                            setColors(prev => ({ ...prev, buttonShadowAngle: value }))
                        }}
                    />
                </Column>
            </Row>
            <Row>
                <Column>
                    <Label>Button shadow blur</Label>
                    <UnitInput
                        value={colors.buttonShadowBlur || "4"}
                        units={['px']}
                        defaultUnit="px"
                        onChange={({ value }) => {
                            setColors(prev => ({ ...prev, buttonShadowBlur: value }))
                        }}
                    />
                </Column>
                <Column>
                    <Label>Button shadow offset</Label>
                    <UnitInput
                        value={colors.buttonShadowOffset || "2"}
                        units={['px']}
                        defaultUnit="px"
                        onChange={({ value }) => {
                            setColors(prev => ({ ...prev, buttonShadowOffset: value }))
                        }}
                    />
                </Column>
            </Row>
        </>
    );
};

export default ColorsTab; 